import { buildRootUrl } from '@/common/app/utils/urlsUtils';

type TLandmarkScheme = Record<
    | 'path'
    | 'name'
    | 'description'
    | 'image'
    | 'latitude'
    | 'longitude'
    | 'destinationName'
    | 'destinationCode'
    | 'touristType',
    string
> &
    Record<'publicAccess' | 'isAccessibleForFree', '0' | '1' | undefined>;

export const createLandmarkScheme = ({
    path,
    name,
    description,
    image,
    latitude,
    longitude,
    destinationName,
    destinationCode,
    touristType,
    publicAccess,
    isAccessibleForFree,
}: TLandmarkScheme) => {
    const url = buildRootUrl(path);

    return JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'TouristAttraction',
        'url': url,
        'name': name,
        'description': description,
        'image': image,
        'publicAccess': publicAccess ? !!+publicAccess : false,
        'isAccessibleForFree': isAccessibleForFree ? !!+isAccessibleForFree : false,
        'geo': {
            '@type': 'GeoCoordinates',
            'latitude': latitude,
            'longitude': longitude,
        },
        'address': {
            '@type': 'PostalAddress',
            'addressLocality': destinationName,
            'addressRegion': destinationCode,
            'addressCountry': 'USA',
        },
        'touristType': touristType ? [touristType] : [],
    });
};
